<template>
  <section class="flight-booking-section">
    <div class="flight-booking-section-body">
      <div class="content-panel" v-for="upsell in stepData" :key="upsell.productType">
        <div class="content-panel">

          <!-- SMS Message with Itinerary -->
          <div class="panel-body" v-if="upsell.productType === 'EXTRA.MOBILE_ITINERARY'">
            <div class="upsell-panel">
              <div class="content">
                <i class="fal fa-mobile"></i>

                <div class="text">
                  <h3>{{ $t('mobileTravelPlan') }}</h3>
                  <p>
                    {{ $t('mobileTravelPlanParagraph') }}
                  </p>
                </div>
              </div>

              <div class="actions">
                <div class="passenger-selection">
                  <h4>{{ $t('mobileTravelPlanOfferParagraph') }}</h4>

                  <ul class="options">
                    <li>
                      <input type="radio" id="mobile_0" :value="0" v-model="upsell.selection" name="mobileItinerary" />
                      <label for="mobile_0">
                        <span>{{ $t('noThanks') }}</span>
                        <span class="price">{{ 0.00 | formatCurrency(currency, 2) }}</span>
                      </label>
                    </li>
                    <li>
                      <input type="radio" id="mobile_opt" :value="upsell.productRelation.offer.price.total" v-model="upsell.selection" name="mobileItinerary" />
                      <label for="mobile_opt">
                        <span>{{ $t('yesPlease') }}</span>
                        <span class="price">
                            {{ upsell.productRelation.offer.price.total | formatCurrency(currency, 2) }}
                          </span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>

          <!-- Flexible Ticket - Re-book Free -->
          <div class="panel-body" v-else-if="upsell.productType === 'EXTRA.AIR_REBOOKING'">
            <div class="upsell-panel">
              <div class="content">
                <i class="fal fa-calendar-star"></i>

                <div class="text">
                  <h3>{{ $t('flexibleTicket')}}</h3>
                  <p>{{ $t('flexibleTicketParagraph') }}</p>
                </div>
              </div>

              <div class="actions">
                <div class="passenger-selection">
                  <div class="passenger" v-for="(pax, index) in upsell.productRelation.offer.options[0].travelerReferences" :key="index">
                    <h4>{{ $t('passenger') }}: {{passengers[pax.travelerReference].firstName}} {{passengers[pax.travelerReference].lastName}}</h4>
                    <ul class="options">
                      <li>
                        <input type="radio" :id="'rebooking_0_' + pax.travelerReference + '_' + index" v-model="pax.selection" :name="'airRebooking' + pax.travelerReference" :value="0" />
                        <label :for="'rebooking_0_' + pax.travelerReference + '_' + index">
                          <span>{{ $t('flexibleTicketDeclined') }}</span>
                          <span class="price">
                            {{ 0.00 | formatCurrency(currency, 2) }}
                          </span>
                        </label>
                      </li>
                      <li>
                        <input type="radio" :id="'rebooking_opt_' + pax.travelerReference + '_' + index" v-model="pax.selection" :name="'airRebooking' + pax.travelerReference" :value="upsell.productRelation.offer.options[0].price.total" />
                        <label :for="'rebooking_opt_' + pax.travelerReference + '_' + index">
                          <span>{{ $t('flexibleTicketAccepted') }}</span>
                          <span class="price">
                            {{ upsell.productRelation.offer.options[0].price.total | formatCurrency(currency, 2) }}
                          </span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- Checked Baggage-->
          <div class="panel-body" v-else-if="upsell.productType === 'EXTRA.BAGGAGE'">
            <div class="upsell-panel">
              <div class="content">
                <i class="fal fa-suitcase-rolling"></i>

                <div class="text">
                  <h3>{{ $t('checkedBaggage') }}</h3>
                  <p>{{ $t('checkedBaggageParagraph') }}</p>
                </div>


              </div>

              <div class="actions">
                <div class="passenger-selection">
                  <div class="passenger" v-for="(pax, index) in upsell.productRelation.offer.options[0].travelerReferences" :key="index">
                    <h4>{{ $t('passenger') }}: {{passengers[pax.travelerReference].firstName}}  {{passengers[pax.travelerReference].lastName}}</h4>

                    <p>{{ $t('maxWeight', {amount: '23KG'}) }}</p>

                    <ul class="options">
                      <li>
                        <input type="radio" :id="'radio1' + index" v-model="pax.selection" value="0" />
                        <label :for="'radio1' + index">
                          <span>{{ $t('checkedBagDecline') }}</span>
                          <span class="price">{{ 0.00 | formatCurrency(currency, 2) }}</span>
                        </label>
                      </li>
                      <li>
                        <input type="radio" :id="'radio2' + index" v-model="pax.selection" :value="upsell.productRelation.offer.options[0].checkedBaggage.maxWeightPerPiece" />
                        <label :for="'radio2' + index">
                          <span>{{ $t('oneBag') }}</span>
                          <span class="price">
                            {{ upsell.productRelation.offer.options[0].price.total | formatCurrency(currency, 2) }}
                          </span>
                        </label>
                      </li>
                    </ul>
                  </div>


                </div>
              </div>
            </div>
          </div>

          <!-- Carry on Baggage -->
          <div class="panel-body" v-else-if="upsell.productType === 'EXTRA.CABIN_BAGGAGE'">
            <div class="upsell-panel">
              <div class="content">
                <i class="fal fa-suitcase-rolling"></i>

                <div class="text">
                  <h3>{{ $t('cabinBaggage') }}</h3>
                  <p>{{ $t('cabinBaggageParagraph') }}</p>
                </div>


              </div>

              <div class="actions">
                <div class="passenger-selection">
                  <h4>{{ $t('cabinBaggageOfferParagraph') }}</h4>

                  <ul class="options">
                    <li>
                      <input type="radio" id="cabinBaggage_0" :value="0" v-model="upsell.selection" name="cabinBaggage" />
                      <label for="cabinBaggage_0">
                        <span>{{ $t('noThanks') }}</span>
                        <span class="price">{{ 0.00 | formatCurrency(currency, 2) }}</span>
                      </label>
                    </li>
                    <li>
                      <input type="radio" id="cabinBaggage_opt" :value="upsell.productRelation.offer.price.total" v-model="upsell.selection" name="cabinBaggage" />
                      <label for="cabinBaggage_opt">
                        <span>{{ $t('oneBag') }}</span>
                        <span class="price">
                            {{ upsell.productRelation.offer.price.total | formatCurrency(currency, 2) }}
                          </span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Cancellation Protection in Europe -->
          <div class="panel-body" v-else-if="upsell.productType === 'EXTRA.INSURANCE_EU'">
            <div class="upsell-panel">
              <div class="content">
                <i class="fal fa-shield-check"></i>

                <div class="text">
                  <h3>{{ $t('tripCancellationProtection') }}</h3>
                  <p>
                    {{ $t('tripCancellationProtectionParagraph') }}
                    <a href="#" @click="showTermsModal('trip-protection-terms')">View Terms &amp; Conditions.</a>
                  </p>
                </div>


              </div>

              <div class="actions">
                <div class="passenger-selection">
                  <div class="passenger" v-for="(pax, index) in upsell.productRelation.offer.options[0].travelerReferences" :key="index">
                    <h4>{{ $t('passenger') }}: {{passengers[pax.travelerReference].firstName}} {{passengers[pax.travelerReference].lastName}}</h4>

                    <ul class="options">
                      <li>
                        <input type="radio" :id="'insuranceeu_0_' + pax.travelerReference + '_' + index" v-model="pax.selection" :name="'insuranceEU' + pax.travelerReference" :value="0" />
                        <label :for="'insuranceeu_0_' + pax.travelerReference + '_' + index">
                          <span>{{ $t('tripCancellationDeclinedParagraph') }}</span>
                          <span class="price">
                            {{ 0.00 | formatCurrency(currency, 2) }}
                          </span>
                        </label>
                      </li>
                      <li>
                        <input type="radio" :id="'insuranceeu_opt_' + pax.travelerReference + '_' + index" v-model="pax.selection" :name="'insuranceEU' + pax.travelerReference" :value="upsell.productRelation.offer.options[0].price.total" />
                        <label :for="'insuranceeu_opt_' + pax.travelerReference + '_' + index">
                          <span>{{ $t('tripCancellationAddedParagraph') }}</span>
                          <span class="price">
                            {{ upsell.productRelation.offer.options[0].price.total | formatCurrency(currency, 2) }}
                          </span>
                        </label>
                      </li>
                    </ul>
                  </div>


                </div>
              </div>
            </div>
          </div>

          <!-- Cancellation Protection outside Europe -->
          <div class="panel-body" v-else-if="upsell.productType === 'EXTRA.INSURANCE_NON_EU'">
            <div class="upsell-panel">
              <div class="content">
                <i class="fal fa-shield-check"></i>

                <div class="text">
                  <h3>{{ $t('tripCancellationProtection') }}</h3>
                  <p>
                    {{ $t('tripCancellationProtectionParagraph') }}
                    <a href="#" @click="showTermsModal('trip-protection-terms')">{{ $t('viewTermsAndConditions') }}</a>
                  </p>
                </div>

              </div>

              <div class="actions">
                <div class="passenger-selection">
                  <div class="passenger" v-for="(pax, index) in upsell.productRelation.offer.options[0].travelerReferences" :key="index">
                    <h4>{{ $t('passenger') }}: {{passengers[pax.travelerReference].firstName}} {{passengers[pax.travelerReference].lastName}}</h4>

                    <ul class="options">
                      <li>
                        <input type="radio" :id="'insurancenoneu_0_' + pax.travelerReference + '_' + index" v-model="pax.selection" :name="'insuranceNonEU' + pax.travelerReference" :value="0" />
                        <label :for="'insurancenoneu_0_' + pax.travelerReference + '_' + index">
                          <span>{{ $t('tripCancellationDeclinedParagraph') }}</span>
                          <span class="price">
                            {{ 0.00 | formatCurrency(currency, 2) }}
                          </span>
                        </label>
                      </li>
                      <li>
                        <input type="radio" :id="'insurancenoneu_opt_' + pax.travelerReference + '_' + index" v-model="pax.selection" :name="'insuranceNonEU' + pax.travelerReference" :value="upsell.productRelation.offer.options[0].price.total" />
                        <label :for="'insurancenoneu_opt_' + pax.travelerReference + '_' + index">
                          <span>{{ $t('tripCancellationAddedParagraph') }}</span>
                          <span class="price">
                            {{ upsell.productRelation.offer.options[0].price.total | formatCurrency(currency, 2) }}
                          </span>
                        </label>
                      </li>
                    </ul>
                  </div>


                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="book-cta">
        <a class="back" @click="$emit('previousStep')"><i class="fal fa-caret-left"></i> {{ $t('goBack') }}</a>
        <button class="btn btn-lg" v-if="!buttonLoader" @click="submitUpsells()">
            <span>{{ $t('continue') }}</span>
        </button>
        <button disabled="disabled" class="btn btn-sec btn-lg progress" v-else>
            <span><i class="fal fa-spinner fa-pulse"></i></span>
        </button>
    </div>

    <!-- Trip Protection Terms & Conditions Modal -->
    <modal name="trip-protection-terms" height="500" :scrollable="true">
      <div class="content-panel">
        <div class="panel-title modal-title">
          <h3>{{ $t('cancellationProtection') }} - {{ $t('termsAndConditions') }}</h3>
          <a @click="hideTermsModal('trip-protection-terms')" class="btn-close" title="Hide"><i class="fal fa-times-circle"></i></a>
        </div>

        <div class="panel-body modal-body">

          <p>{{ $t('cancellationProtectionParagraph1') }}</p>

          <p>{{ $t('cancellationProtectionParagraph2') }}</p>

          <p>{{ $t('cancellationProtectionParagraph3') }}</p>

          <h4>{{ $t('reimbursableIncidents') }}</h4>

          <h5>{{ $t('cancellationProtectionParagraph4') }}</h5>

          <ol>
            <li>{{ $t('cancellationProtectionBullet1') }}</li>
            <li>{{ $t('cancellationProtectionBullet2') }}</li>
          </ol>

          <h5>{{ $t('cancellationProtectionParagraph5') }}:</h5>

          <ol>
            <li>{{ $t('cancellationProtectionBullet3') }}</li>
            <li>{{ $t('cancellationProtectionBullet4') }}</li>
            <li>{{ $t('cancellationProtectionBullet5') }}</li>
            <li>{{ $t('cancellationProtectionBullet6') }}</li>
            <li>{{ $t('cancellationProtectionBullet7') }}</li>
            <li>{{ $t('cancellationProtectionBullet8') }}</li>
            <li>{{ $t('cancellationProtectionBullet9') }}</li>
            <li>{{ $t('cancellationProtectionBullet10') }}</li>
            <li>{{ $t('cancellationProtectionBullet11') }}</li>
            <li>{{ $t('cancellationProtectionBullet12') }}</li>
          </ol>

          <h5>{{ $t('whatWeRequireFromYou') }}</h5>

          <p>{{ $t('cancellationProtectionParagraph6') }}</p>

          <h5>{{ $t('cancellationProtectionParagraph7') }}:</h5>

          <ol>
            <li>{{ $t('cancellationProtectionBullet13') }}</li>
            <li>{{ $t('cancellationProtectionBullet14') }}</li>
            <li>{{ $t('cancellationProtectionBullet15') }}</li>
            <li>{{ $t('cancellationProtectionBullet16') }}</li>
            <li>{{ $t('cancellationProtectionBullet17') }}</li>
          </ol>
        </div>

      </div>


    </modal>
  </section>
</template>

<script>
import ancillaryInfo from '../../assets/data/ancillaryInfo.json';

export default {
  name: 'FlightBookingUpsells',
  data() {
    return {
      stepData: [],
      showMoreAncillaries: false,
      buttonLoader: false,
      ancillaryInfo: ancillaryInfo
    }
  },
  mounted() {
    for(let upsellIndex in this.upsellData.availableExtraProducts) {
      let upsell = this.upsellData.availableExtraProducts[upsellIndex];
      this.$set(upsell, 'showAction', false);

      this.stepData.push(upsell);
    }
  },
  methods: {
    defaultSelections(upsell) {
      for(let optionIndex in upsell.productRelation.offer.options) {
        let option = upsell.productRelation.offer.options[optionIndex];
        for (let travelerIndex in option.travelerReferences){
          let traveler = option.travelerReferences[travelerIndex];
          this.$set(option.travelerReferences, travelerIndex, {travelerReference: traveler, selection: '0'})
        }
      }
    },
    submitUpsells() {
      this.buttonLoader = true;
      this.$emit('nextStep', this.stepData);
    },

    showTermsModal (modal) {
      this.$modal.show(modal);
    },
    hideTermsModal (modal) {
      this.$modal.hide(modal);
    }
  },
  props: ['upsellData', 'currency', 'passengers']
}
</script>